"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _SchemaBase = _interopRequireDefault(require("./SchemaBase"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const SchemaEditor = props => {
  const schema = props.schema,
        uiSchema = props.uiSchema,
        registry = props.registry,
        formContext = props.formContext;
  const languages = formContext.languages || ["en"];
  const defaultLocale = languages[0];

  const _useState = (0, _react.useState)(props.formData || undefined),
        formData = _useState[0],
        setFormData = _useState[1];

  const _useState2 = (0, _react.useState)(formContext.currentLocale || defaultLocale),
        currentLocale = _useState2[0],
        setCurrentLocale = _useState2[1];

  const _useState3 = (0, _react.useState)(formContext.currentId),
        currentId = _useState3[0],
        setCurrentId = _useState3[1];

  const onChange = ({
    formData
  }) => {
    setFormData(formData);
    props.onChange && props.onChange({
      formData
    });
  };

  const onCurrentId = currentId => {
    console.log('onCurrentId', currentId);
    setCurrentId(currentId);
    props.onCurrentId && props.onCurrentId(currentId);
  };

  const onToggleId = id => {
    if (!id) {
      return false;
    }

    let parentId = id.split('_');
    parentId.pop();
    parentId = parentId.join('_');
    let expandId = undefined;

    if (id && currentId && currentId.startsWith(id)) {
      expandId = parentId;
    } else {
      expandId = id;
    }

    onCurrentId(expandId);
  };

  const onEdit = (_ref) => {
    let id = _ref.id,
        props = _objectWithoutPropertiesLoose(_ref, ["id"]);

    onToggleId(id);
  };

  const onSave = (_ref2) => {
    let id = _ref2.id,
        props = _objectWithoutPropertiesLoose(_ref2, ["id"]);

    onToggleId(id);
  };

  const onExpand = (_ref3) => {
    let id = _ref3.id,
        props = _objectWithoutPropertiesLoose(_ref3, ["id"]);

    onToggleId(id);
  };

  const onCollapse = (_ref4) => {
    let id = _ref4.id,
        props = _objectWithoutPropertiesLoose(_ref4, ["id"]);

    onToggleId(id);
  };

  const onToggle = (_ref5) => {
    let id = _ref5.id,
        props = _objectWithoutPropertiesLoose(_ref5, ["id"]);

    onToggleId(id);
  };

  const onLocale = locale => {
    setCurrentLocale(locale);
  };

  const onUpload = (upload, event) => {
    formContext.onUpload && formContext.onUpload(upload, event);
  };

  const onDialog = (dialog, event) => {
    formContext.onDialog && formContext.onDialog(dialog, event);
  };

  const onAfterChange = props => {
    console.log('afterChange', props);
  };

  const onAfterAdd = ({
    id,
    formData
  }) => {
    console.log('afterAdd', id);
    const index = formData && formData.length && formData.length - 1;
    const itemId = id + "_" + index;
    onCurrentId(itemId);
  };

  const onAfterRemove = ({
    id
  }) => {
    onCurrentId(id);
  };

  const onSelect = select => {
    props.onSelect && props.onSelect(select);
  };

  const onSubmit = submit => {
    props.onSubmit && props.onSubmit(submit);
  };

  return _react.default.createElement(_SchemaBase.default, _extends({}, registry, {
    schema: schema,
    uiSchema: uiSchema,
    formData: formData,
    formContext: _extends({}, formContext, {
      languages: languages,
      defaultLocale: defaultLocale,
      currentLocale: currentLocale,
      currentId: currentId,
      onLocale: onLocale,
      onExpand: onExpand,
      onCollapse: onCollapse,
      onToggle: onToggle,
      onEdit: onEdit,
      onSave: onSave,
      onUpload: onUpload,
      onDialog: onDialog,
      onAfterChange: onAfterChange,
      onAfterAdd: onAfterAdd,
      onAfterRemove: onAfterRemove,
      onSelect: onSelect,
      onSubmit: onSubmit
    }),
    onChange: onChange
  }));
};

SchemaEditor.defaultProps = {
  uniqueId: undefined,
  parentId: undefined,
  referenceId: undefined,
  schema: undefined,
  uiSchema: undefined,
  formData: undefined,
  formContext: {},
  registry: {
    fieldtypes: {},
    fields: {},
    layouts: {},
    widgets: {}
  }
};
var _default = SchemaEditor;
exports.default = _default;
module.exports = exports.default;